// src/pages/public/AnnouncementPublic.jsx
import React, { useEffect, useMemo, useState, Suspense } from 'react';
import T1 from "../../../components/announcements/templates/t1/T1";
import T2 from "../../../components/announcements/templates/t2/T2";
import T3 from "../../../components/announcements/templates/t3/T3";

const TEMPLATE_MAP = {
  t1: T1,
  t2: T2,
  t3: T3,
};

export default function AnnouncementPublic() {
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    let isMounted = true;

    fetch(`${process.env.REACT_APP_API}/announcements/current`, {
      method: 'GET',
      cache: 'no-store',
    })
      .then(async (res) => {
        if (!isMounted) return;
        if (res.status === 204) {
          setState({ loading: false, error: null, data: null });
          return;
        }
        if (!res.ok) {
          const txt = await res.text().catch(() => '');
          throw new Error(`HTTP ${res.status} ${txt}`);
        }
        const json = await res.json();
        setState({ loading: false, error: null, data: json });
      })
      .catch((err) => {
        if (!isMounted) return;
        setState({ loading: false, error: err.message || 'Erro ao carregar', data: null });
      });

    return () => { isMounted = false; };
  }, []);

  if (state.loading) {
    return (
      <div style={{ fontFamily:'Arial, sans-serif', padding: 24 }}>
        Carregando anúncio...
      </div>
    );
  }

  if (state.error) {
    return (
      <div style={{ fontFamily:'Arial, sans-serif', padding: 24, color:'#b91c1c' }}>
        Erro: {state.error}
      </div>
    );
  }

  if (!state.data) {
    return (
      <div style={{ fontFamily:'Arial, sans-serif', padding: 24 }}>
        Sem anúncio ativo no momento.
      </div>
    );
  }

  const { template_key, ...props } = state.data;
  const Template = TEMPLATE_MAP[template_key] || (() => (
    <div style={{ fontFamily:'Arial, sans-serif', padding:24 }}>
      Template desconhecido: <strong>{String(template_key)}</strong>
    </div>
  ));

  // Se você trocar para lazy(), envolva com <Suspense/>
  return (
    // <Suspense fallback={<div style={{padding:24}}>Carregando template...</div>}>
    <Template {...props} />
    // </Suspense>
  );
}
